import { Box, Flex, Text, Tooltip } from '@modusign/design-system';

export default function InPersonHostInfoBadge({
  name,
  contactInfo,
  offset = {},
}: {
  name: string;
  contactInfo: string;
  offset?: {
    offsetX?: number;
    offsetY?: number;
  };
}) {
  return (
    <Tooltip
      content={
        <Box>
          <Box>
            <Text fontSize="xs" fontWeight="medium">
              진행자 : {name}
            </Text>
          </Box>
          <Box>
            <Text fontSize="xs" fontWeight="medium">
              {contactInfo}
            </Text>
          </Box>
        </Box>
      }
      placement="top"
      {...offset}
    >
      <Box display="inline-block">
        <Flex
          alignItems="center"
          backgroundColor="statusBackgroundNeutralBase"
          borderRadius="10px"
          color="textNeutralLight"
          display="flex"
          fontSize="10px"
          fontWeight="medium"
          height="19px"
          justifyContent="center"
          width="52px"
        >
          대면서명
        </Flex>
      </Box>
    </Tooltip>
  );
}
